<template>
  <div class="item_slider_main"> 

    <div id="image_slider" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators mb0"  v-if="images.length > 1">
        <li data-target="#image_slider" data-slide-to="index"  :class="{active: index == 0}"  v-for="(image, index) in images" :key="index"></li> 
      </ol>
      <div class="carousel-inner"> 
        <div class="carousel-item " :class="{active: index == 0}"  v-for="(image, index) in images" :key="index">      
            <div class="back-image bg-white text-white">
              <span v-if="image.caption_1" style="position: absolute; bottom: 0; background: #00000069; padding: 10px; width: 100%;">  
                <p v-if="image.caption_1">{{ image.caption_1}} </p>
              </span>
              <img v-lazy="image.image_url" class="img-fluid" />  
            </div> 
        </div> 
      </div>

      <template v-if="images.length > 1">
          <a class="carousel-control-prev" href="#image_slider" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#image_slider" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
      </template>
     
    </div>
    <!-- <div
      v-for="i in [currentIndex]"
      :key="i"
      class="item_image bg-white"
      :style="{ 'background-image': 'url(' + currentImg + ')' }"
    >
          <img class="img-fluid" :src="currentImg" alt="">
    </div>
    <a class="item_slider_prev" v-if="images.length > 1" @click="prev" href="#">
      <img src="@/assets/icon/left.svg" width="40" alt=""
    /></a>
    <a class="item_slider_next" v-if="images.length > 1" @click="next" href="#">
      <img src="@/assets/icon/right.svg" width="40" alt="" />
    </a> -->
  </div>
</template>

 <style lang="css" scoped>
 .mb0{
    margin-bottom: 0px;
 }
.item_image {
  position: relative;
  /* height: 100%; */
  /* height: 350px;
  width: 480px; */
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: 50% 50%; */
}

 

.item_slider_main {
  position: relative;
  margin: 0px auto; 
  top: 0px;
  left: 0px;
  overflow: hidden;
  visibility: visible;
}
.item_slider_next {
  width: 55px;
  height: 55px;
  z-index: 1;
  display: block;
  position: absolute;
  top: 148px;
  right: 0;
}
.item_slider_prev {
  width: 55px;
  height: 55px;
  z-index: 1;
  display: block;
  position: absolute;
  top: 148px;
  left: 0;
}
@media only screen and (max-width: 991.5px) {
  .item_slider_next,
  .item_slider_prev {
    top: 160px !important;
  }
  .item_slider_main { 
    margin-top: 0px;
  }
}
</style>
<script >
export default {
  name: "baseItemSlider",
  props: {
    images: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      timer: null,
      currentIndex: 0,
    };
  },
  mounted: function () {
    this.startSlide();
  },

  methods: {
    startSlide: function () {
      this.timer = setInterval(this.next, 15000);
    },

    next: function () {
      this.currentIndex += 1;
    },
    prev: function () {
      this.currentIndex -= 1;
    },
  },

  computed: {
    currentImg: function () {
      if (this.images.length == 0) {
        return require("@/assets/placeholder.svg");
      }

      return this.images[Math.abs(this.currentIndex) % this.images.length].image_url;
    },
  },
};
</script>